// React
import { useEffect, useState } from "react"

// Types
import type { SelectOptionType, SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export interface ShiftType extends SelectOptionType {
  in_time: string
  out_time: string
}

export function useShift() {

  // Hooks
  const api = useApi()
  const [data, setData] = useState<ShiftType[]>([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    refetch()
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  function refetch() {
    setLoading(true)

    api.get("/shift/list-shift").then((res: SuccessFetch<{
      payload: {
        mr_shift_id: number
        mr_shift_name: string
        out_time: string
        in_time: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.mr_shift_name,
          value: item.mr_shift_id.toString(),
          in_time: item.in_time,
          out_time: item.out_time
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  return { data, isLoading, refetch }
}